import { createSelector } from 'reselect'
import { State } from 'index'

const shopSubscriptionSelector = (state: State) => state.shopSubscription

export const getInvoices = createSelector([shopSubscriptionSelector], (state) => state.invoices)
export const getSubscriptionStoreRefs = createSelector([shopSubscriptionSelector], (state) => state.store_refs)
export const getSubscriptions = createSelector([shopSubscriptionSelector], (state) => state.subscriptions)
export const getSubscriptionSchedules = createSelector(
  [shopSubscriptionSelector],
  (state) => state.subscription_schedules
)
export const getShopSubscriptions = createSelector([shopSubscriptionSelector], (state) => state.shop_subscriptions)
